import React from "react";
import { Link } from "gatsby";

const PageAnchorLink = ({
  page,
  linkText,
  switchRef,
  target,
  children,
  ...rest
}) => {
  return (
    <Link
      to={`/${page?.slug?.current}#${
        target &&
        target?.current
          ?.toLowerCase()
          .replace(/\s+/g, "-")
          .replace(",", "")
          .replace("&", "and")
      }`}
      ref={switchRef}
      {...rest}
    >
      {linkText || children}
    </Link>
  );
};

export default PageAnchorLink;
